<template>
  <ZigzagServiceLayout
    mainTitle="Terapias com Vitaminas IM/IV"
    mainDescription="Energia, equilíbrio e bem-estar de dentro para fora. Nossas terapias IV fornecem hidratação, nutrientes e antioxidantes diretamente no seu sistema para uma absorção mais rápida."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'IMIVVitaminTherapiesContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'HIDRATAÇÃO E RECUPERAÇÃO',
          title: 'Bem-estar e Hidratação de Corpo Inteiro',
          subtitle: 'Restaure o equilíbrio com eletrólitos, vitaminas e antioxidantes.',
          paragraphs: [
            "Nossas terapias de hidratação IV são projetadas para reabastecer rapidamente os fluidos e nutrientes do corpo.",
            "Se você precisa de uma recuperação após fadiga, viagens ou dias estressantes, nossas infusões supervisionadas proporcionam alívio imediato e bem-estar duradouro."
          ],
          list: [
            "Hidratação corporal completa com eletrólitos",
            "Suporte antioxidante para a saúde imunológica",
            "Rápida recuperação da fadiga e do estresse",
            "Alívio dos sintomas de viagem e jet lag"
          ],
          image: '/images/services/iv-hydration.png'
        },
        {
          label: 'DESEMPENHO',
          title: 'Energia, Metabolismo e Controle de Peso',
          subtitle: 'Aumente a energia e a recuperação pós-treino.',
          paragraphs: [
            "Infusões sob medida carregadas com B12, aminoácidos essenciais e vitaminas B ajudam a otimizar seus níveis de energia e função metabólica.",
            "Essas terapias são ideais para apoiar o gerenciamento seguro do peso e acelerar a recuperação após exercícios intensos."
          ],
          list: [
            "B12 e aminoácidos para aumento natural de energia",
            "Melhora do metabolismo e do controle de peso",
            "Recuperação muscular pós-treino mais rápida",
            "Foco e vitalidade aprimorados"
          ],
          image: '/images/services/iv-energy.png'
        },
        {
          label: 'ESTÉTICA',
          title: 'Saúde da Pele e Rejuvenescimento',
          subtitle: 'Apoie sua pele, cabelos e o brilho natural.',
          paragraphs: [
            "Nutre sua beleza por dentro. Nossas misturas de vitaminas especializadas apoiam cabelos e peles brilhantes e saudáveis.",
            "Esses tratamentos rejuvenescedores são seguros e formulados para realçar o seu brilho natural e combater os sinais de envelhecimento."
          ],
          list: [
            "Misturas de vitaminas para um brilho natural",
            "Suporte para crescimento saudável de cabelos e unhas",
            "Proteção antioxidante antienvelhecimento",
            "Hidratação para uma pele visivelmente jovem"
          ],
          image: '/images/services/iv-beauty.png'
        }
      ]
    };
  }
};
</script>
